import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "@/components/icons";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="w-8 h-8 animate-spin text-brand" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace state={{ from: `${location.pathname}${location.search}` }} />;
  // Item 1.3 — usuário com must_change_password fica preso na tela de troca
  // até concluir com sucesso. Este redirect tem PRIORIDADE sobre o guard de
  // módulo abaixo — caso contrário, cai em loop `/trocar-senha` <-> `/logistica`.
  if (user.must_change_password && location.pathname !== "/trocar-senha") {
    return <Navigate to="/trocar-senha" replace />;
  }
  // Módulo Logística — perfis isolados do CRM comercial.
  // Exceção: a própria tela `/trocar-senha` fica liberada para ambos os perfis
  // logísticos concluírem a troca obrigatória no 1º acesso.
  if (location.pathname !== "/trocar-senha") {
    // TV Corporativa só enxerga /tv (modo quiosque).
    if (user.role === "tv_corporativa" && !location.pathname.startsWith("/tv")) {
      return <Navigate to="/tv" replace />;
    }
    // Adm Logístico só enxerga /logistica.
    if (user.role === "logistica_adm" && !location.pathname.startsWith("/logistica")) {
      return <Navigate to="/logistica" replace />;
    }
  }
  return children;
}
